export class EntitySummaryModel {
  public id?: number;
  public name: string;
  public description: string;
}

export class EntityModel {
  public id?: number;
  public name: string;
  public description: string;
  public country_id: number;
  public state_id: number;
  public vat_code: string;
  public address_number: string;
  public address_1: string;
  public address_2: string;
  public url: string;
  public contact_1: string;
  public contact_2: string;
  public note_1: string;
  public note_2: string;
  public note_3: string;
  public logo_name: string;
  public logo: string;
}



// WEBPACK FOOTER //
// ./src/app/models/entity.model.ts